import React from 'react';
import { Chip, TableCell } from '@mui/material';
import CheckCircleOutlineIcon  from '@mui/icons-material/CheckCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

export const ROLE_COLORS   = { Admin: 'primary', Regular: 'success', Tourist: 'default' };
export const VENDOR_COLORS = { Ericsson: 'warning', Nokia: 'secondary', Both: 'error' };

export const AVATAR_COLORS = {
    Admin:   { bg: '#E3F2FD', color: '#1565C0' },
    Regular: { bg: '#E8F5E9', color: '#2E7D32' },
    Tourist: { bg: '#F5F5F5', color: '#616161' },
};

export const getInitials = (name = '') =>
    name.split(' ').map((n) => n[0]).join('').substring(0, 2).toUpperCase();

export function RoleBadge({ role }) {
    return (
        <Chip
            label={role}
            size="small"
            color={ROLE_COLORS[role] || 'default'}
            variant="outlined"
        />
    );
}

export function VendorBadge({ vendor }) {
    return (
        <Chip
            label={vendor}
            size="small"
            color={VENDOR_COLORS[vendor] || 'default'}
            variant="outlined"
        />
    );
}

export function BoolCell({ value }) {
    return (
        <TableCell align="center">
            {value
                ? <CheckCircleOutlineIcon  fontSize="small" color="success" />
                : <RemoveCircleOutlineIcon fontSize="small" sx={{ color: 'text.disabled' }} />}
        </TableCell>
    );
}